import { CustomJrpcErrResult } from '../jsonRpc/jRpcErrResponse';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type ConfirmEmailOtpAuthRequest = {
    email: string,
    otp: string,
    locale: string
    current_entry_point: string
}

export type ConfirmEmailOtpAuthResponse = {
    tether: {
        suid: string;
        token: string;
    };
};

export function confirmEmailOtpAuth(data: ConfirmEmailOtpAuthRequest): Promise<ConfirmEmailOtpAuthResponse | CustomJrpcErrResult> {
    const hubApi = getHubApi();
    return hubApi.confirmEmailOtpAuth(window.app.deviceIdentifier, data) as Promise<ConfirmEmailOtpAuthResponse>;
}
